import * as React from "react";
import { LazyRender } from "sb-resp-ui";
export class SuperBannerItem extends React.Component {
    render() {
        let cls = "rj-superbanner__item" + (this.props.modifier ? ` ${this.props.modifier}` : "");
        cls += this.props.clientHashedClass ? ` ${this.props.clientHashedClass}` : "";
        let dataUat = "superbanner-item" + (this.props.modifier ? `-${this.props.modifier}` : "");
        const styles = this.props.width ? { width: `${this.props.width}px` } : undefined;
        return React.createElement("div", { style: styles, className: cls, "data-uat": dataUat, "data-includein": this.props.clientHashedAttribute },
            React.createElement(LazyRender, { baseMinHeight: 0 }, this.props.children));
    }
}
//# sourceMappingURL=SuperBannerItem.js.map